import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskLamp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDeskLamp"><Path d="M15.406 3C17.6612 3.0001 19.915 4.31599 20.5495 6.6377C20.8653 7.79313 21.046 8.99375 20.989 10.2832L20.9577 11H17.9997V17H16.4997V11H12.7497V19.5H16.9997V21H6.99974V19.5H11.2497V11H3.04173L3.01048 10.2832C2.95334 8.9937 3.1341 7.79316 3.44993 6.6377C4.08459 4.31599 6.33825 3.00002 8.59349 3H15.406Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDeskLamp;
